import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-trav-exp-type-menu',
  templateUrl: './trav-exp-type-menu.component.html',
  styleUrls: ['./trav-exp-type-menu.component.css']
})
export class TravExpTypeMenuComponent implements OnInit {
    trexTypeId;

    public menu?: Menu;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.trexTypeId = this.stateService.getStateParams()['trextype_id'];
    }

    private async loadMenu() {
        if (!!this.trexTypeId) {
            this.menu = (await this.datatask.Post(1269, { trextype_id: this.trexTypeId }))[0];
        }
    }

    public async deleteValues() {
        if (!!this.menu) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    await this.datatask.Post(1273, { trextype_id: this.menu.trextype_id });

                    this.stateService.back();
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private async init() {
        this.loadMenu();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    trextype_id: string;
    trextype_lang_name: string;
    activestatus: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('travExpTypeMenu', {
//        templateUrl: 'views/components/views/travExpTypeMenu/travExpTypeMenu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'travExpTypeMenuService', 'layoutService', function ($stateParams, stateService, translateService, modalService, travExpTypeMenuService, layoutService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let trexTypeId = $stateParams.trextype_id;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                tabletSize: layoutService.getMediaQueries().tablet,
//                menu: {},
//                lockedDelete: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE CALL

//            async function loadMenu() {
//                vm.model.menu = (await travExpTypeMenuService.getTravelExpenceType({ trextype_id: trexTypeId }))[0];
//            }

//            // #endregion LOAD PROCEDURE CALL

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(() => {
//                    travExpTypeMenuService.deleteItem({ trextype_id: vm.model.menu.trextype_id }).then(() => {
//                        vm.model.lockedDelete = false;
//                        stateService.back();
//                    }, () => vm.model.lockedDelete = false);
//                }, () => vm.model.lockedDelete = false);
//            }

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadMenu();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
